export const APP_FILE_ALL_APPLICATION_HR = "/all-applications";
export const APP_FILE_ON_BORADING_LIST= "/on-boarding";
export const APP_FILE_ON_BORADING_LISTS = "/on-boardings";
export const APP_FILE_OFF_BOARDING = "/user-offboarding";
export const APP_FILE_REQUEST_FORMS_LIST = "/request-forms";
